// extracted by mini-css-extract-plugin
module.exports = {"upload":"CoverUpload_upload__yrpDQ","overlay":"CoverUpload_overlay__3oxE2"};